import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, accountsService } from '@v2/services';
import type { AccountPayload } from '@v2/types';

export const useCreateAccount = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: accountsService.createAccount,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.accounts.all);
    },
  });

  const createAccount = async (data: AccountPayload): Promise<string | null> => {
    try {
      return await mutation.mutateAsync(data);
    } catch {
      return null;
    }
  };

  return {
    createAccount,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useCreateAccount;
